/**
 * Generic "coming soon" admin page.
 *
 * Same UX as PortalPlaceholder but with admin i18n namespace so the wording
 * is admin-flavoured.
 */
import PortalPageHeader from "../../components/portal/PortalPageHeader";
import PortalEmptyState from "../../components/portal/PortalEmptyState";

export default function AdminPlaceholder({ titleKey, descKey, icon: Icon, testId }) {
  return (
    <div data-testid={testId} className="space-y-10">
      <PortalPageHeader
        kickerKey="admin.placeholder.kicker"
        titleKey={titleKey}
        subtitleKey={descKey}
      />

      <PortalEmptyState
        variant="dashed"
        icon={Icon}
        titleKey="admin.placeholder.soon_title"
        descKey="admin.placeholder.soon_desc"
      />
    </div>
  );
}
